var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('admin_con',{staticClass:"iconNull",attrs:{"type":"icon-kongshuju"}}),_c('div',{staticClass:"messageNull"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }